/**
 * Module catalogue: the module IDs this release knows about (brief §8.1).
 * Adding a module = add its ID here (with a version bump), seed it in tenant-api,
 * and register it in the mobile app's module registry. See docs/ARCHITECTURE.md.
 */
export const MODULE_CATALOGUE = [
  {
    id: 'announcements',
    title: 'Announcements',
    icon: 'megaphone',
    readOnlySafe: true,
    teacher: true,
  },
  {
    id: 'attendance',
    title: 'Attendance',
    icon: 'check-square',
    readOnlySafe: false,
    teacher: true,
  },
  { id: 'timetable', title: 'Timetable', icon: 'calendar', readOnlySafe: true, teacher: true },
  { id: 'duty-roster', title: 'Duty roster', icon: 'clipboard', readOnlySafe: true, teacher: true },
  { id: 'requests', title: 'Requests', icon: 'inbox', readOnlySafe: false, teacher: true },
] as const;

export type ModuleId = (typeof MODULE_CATALOGUE)[number]['id'];

export const MODULE_IDS: readonly ModuleId[] = MODULE_CATALOGUE.map((m) => m.id);

export const MODULE_ID_PATTERN = /^[a-z][a-z0-9-]{1,39}$/;

/**
 * Manifest module ids (additive, Phase 2 plug-ins): a core module id, or a middleware module
 * id `<middleware>.<module>` with exactly one dot (middlewares.ts).
 */
export const MANIFEST_MODULE_ID_PATTERN = /^[a-z][a-z0-9-]{1,39}(\.[a-z][a-z0-9-]{1,39})?$/;

/** `module.<id>.use` or `module.<middleware>.<module>.use`. */
export const MANIFEST_MODULE_PERMISSION_PATTERN =
  /^module\.[a-z][a-z0-9-]*(\.[a-z][a-z0-9-]*)?\.use$/;

export function isKnownModuleId(id: string): id is ModuleId {
  return (MODULE_IDS as readonly string[]).includes(id);
}

export function modulePermission(id: string): `module.${string}.use` {
  return `module.${id}.use`;
}
